export function getMockedResponse(response, timeout = 500) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(response)
    }, timeout)
  })
}
